import { EATON_USER_DOMAIN, LOGIN_EMAIL_ID } from "../../constants"

export const checkLoginEmailId = (email: string) => {
    return email.toLocaleLowerCase().endsWith(LOGIN_EMAIL_ID)
}

export const isEatonEmailId = (email: string) => {
    return email.toLocaleLowerCase().endsWith(EATON_USER_DOMAIN)
}

export const formatDate = (timestamp: any) => {
    const date = new Date(timestamp)
    const sDate = date.getDate();
    const sYear = date.getFullYear();
    const month = date.getMonth() + 1;
    if (month <= 9) {
        return `${sDate}/0${month}/${sYear}`
    } else {
        return `${sDate}/${month}/${sYear} `;
    }
}

export function formatTime(timestamp: any) {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const isPM = hours >= 12;
    hours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const period = isPM ? 'PM' : 'AM';
    return `${hours}:${formattedMinutes}${period}`;
}

export function filterDataByCompletionDate(data: any[], startDate: Date, endDate: Date): any[] {
    return data.filter((item) => {
        const completionDate = new Date(item.completionDate).getTime();
        return completionDate >= endDate.getTime() && completionDate <= startDate.getTime();
    });
}

export function decodeJWT(token: string): Record<string, any> | null {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Invalid JWT:', error);
        return null;
    }
}

export function convertUnixToDate(timestamp: number): string {
    const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
    return date.toUTCString(); // Returns in UTC format
}
